import React from 'react';
import { useBrowser } from '../use-browser/use-browser.js';

/**
 * @since 9.4.0
 *
 * Adds a delay between toggling the `hidden` attribute and the `--active` modifier.
 * 250ms is the default transition time for honeycomb animations.
 * If the two props are set at the same time, the CSS transition doesn't happen.
 *
 * @param {boolean} active - indicates if the component is active
 * @return `[boolean, boolean]` respective values for `hidden` attribute and `--active` modifier
 */
function useDelayedHidden(active) {
  const [win] = useBrowser();
  const [hiddenAttr, setHiddenAttr] = React.useState(!active);
  const [activeModifier, setActiveModifier] = React.useState(active);
  React.useEffect(() => {
    if (active) {
      setHiddenAttr(false);
      win === null || win === void 0 ? void 0 : win.setTimeout(() => {
        setActiveModifier(true);
      }, 50);
    }
    if (!active) {
      win === null || win === void 0 ? void 0 : win.setTimeout(() => {
        setHiddenAttr(true);
      }, 250);
      setActiveModifier(false);
    }
  }, [active]);
  return [hiddenAttr, activeModifier];
}

export { useDelayedHidden };
